import React from 'react';
import { ReactComponent as EmployeeIcon } from '../reportproblem/images/employee.svg';
import { ReactComponent as CitizenIcon } from '../reportproblem/images/citizen.svg';

export default function ReportTypeSelection({ increaseFormStep, setFormInfo }) {
  const setProblemType = (value) => {
    setFormInfo((prevValue) => {
      return {
        ...prevValue,
        problemType: value,
      };
    });

    if (value === 'citizens') increaseFormStep();
    else {
      increaseFormStep();
      increaseFormStep();
    }
  };

  return (
    <div>
      <div className="report-problem-cards">
        <div className="report-problem-body">
          <div
            className="report-problem-card"
            onClick={() => setProblemType('citizens')}
          >
            <CitizenIcon className="report-problem-card-icon" />

            <h2 className="report-problem-text">GRAĐANI</h2>
          </div>
        </div>
        <div className="report-problem-body">
          <div
            className="report-problem-card"
            onClick={() => setProblemType('employees')}
          >
            <EmployeeIcon className="report-problem-card-icon" />

            <h2 className="report-problem-text">UPOSLENIK</h2>
          </div>
        </div>
      </div>
    </div>
  );
}
